
export const text_rus = [
    //0
    'FA.Unit&USDT Exchange',
    //1
    'Как это работает',
    //2
    'Copyright 2017-2020 © N.KRAT Group AG, All rights reserved.',
    //3
    'Оформить заявку',
    //4
    'Ваш Email в системе Fridn',
    //5
    'Ваш пароль',
    //6
    'Вид обмена',
    //7
    'Ваш USDT кошелек',
    //8
    'Внимание! Использовать только личный кошелек',
    //9
    'USDT wallet',
    //10
    'Сколько FA.Unit вы хотите обменять?',
    //11
    'Сумма FA.Unit',
    //12
    'Я прочитал правила сервиса',
    //13
    'Отменить',
    //14
    'Дальше',
    //15
    'Обменять',
    //16
    'Как это работает',
    //17
    'USDT Кошелек системы Fridn, на который необходимо перевести средства',
    //18
    'С указанного на первом шаге USDT кошелька необходимо отправить сумму, на которую вы хотите произвести обмен - из расчета 1 USDT = 1 FA.Unit',
    //19
    'После поступления средств с указанного кошелка, система автоматически начислит FA.Unit на указанный аккаунт',
    //20
    'Комиссия на получение FA.Unit: 0%',
    //21
    'Комиссию блокчейна Ethereum перенимает отправитель',
    //22
    'Зачисление FA.Unit происходит в течении 2 часов с момента поступления USDT',
    //23
    'Минимальная сумма для получения FA.Unit 10.00 USDT',
    //24
    'Важно',
    //25
    '- Система автоматически привязывает, указанный вами кошелек к вашему аккаунту в системе Fridn',
    //26
    '- при повторном переводе USDT, с уже указанного кошелька, ваши юниты будут зачислены на ваш аккаунт в Fridn автоматически',
    //27
    '- Если вы хотите использовать для оплаты другой кошелек, вы должны его снова зарегистрировать, путем заполнения данных на сайте https://fridn.io/usdt_exchange/',
    //28
    '- За перевод средств с незарегистрированного кошелька, будет взыматься комиссия в размере 12% с суммы обмена',
    //29
    'Чтобы перейти дальше на сайт fridn.com, необходимо скопировать кошелек системы, путем нажатия на кнопку «Copy» в поле с кошельком USDT',
    //30
    'Go to fridn.com',
    //31
    'Вы отправили указанное количество FA.Unit с Вашего аккаунта в адрес оператора системы',
    //32
    'Система Fridn обрабатывает запросы отправки USDT в автоматическом режиме',
    //33
    'Комиссия на получение USDT: 3% + комиссия блокчейна Ethereum',
    //34
    'Оформление запроса в блокчейн Ethereum на отправку USDT оформляется в течении 30 минут  с момента зачисления FA.Unit на кошелек оператора/скорость зачисления USDT зависит от сети Ethereum и может занимать до 2 часов.',
    //35
    'USDT будут отправлены на кошелек, который указан в форме. Fridn не несет ответственности за неправильно введенные данные, а транзакции не могут быть отозваны.',
    //36
    '',
    //37
    'Покупка FA.Unit (USDT-->FA.Unit), комиссия 0%',
    //38
    'Покупка USDT (FA.Unit-->USDT), комиссия системы 3% + комиссия Ethereum',
    //39
    'Вы успешно зарегистрировались для перевода USDT в FA.Unit',
    //40
    'Вы уже зарегистрировали этот кошелек USDT',
    //41
    'Подтверждение',
    //42
    'начало новой регистрации',
    //43
    'начало новой транзакции',
    //44
    'Отмена',
    //45
    'Продолжить',
    //46
    'Подтвердите, что вы согласны',
    //47
    'Комиссия сети Эфир за проведение транзакций с USDT зависит от ее загруженности. Если вы хотите вывести средства с меньшей комиссией, прервите транзакцию и попробуйте вывести средства в другое время (самые выгодные комиссии - вечером или рано утром). Если размер комиссии вас устраивает, нажмите на кнопку "Продолжить"',
    //48
    'Комиссия сети Эфир',
    //49
    'Вам будет зачислено',
];
